import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT } from '../../../../constants';

import { getPartner } from '../../../../services/partner/selector';

import { getPartnerIdFromQuery } from '../../../../utils';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import PaymentFailureBloc from './PaymentFailureBloc';
import ProviderUnavailableBloc from './ProviderUnavailableBloc';

import './ErrorEbonPage.scss';

const ErrorEbonPage = ({
    i18n,
    BRAND_NAME,
    ebcPartnerId,
    paymentId,
    partner,
    status,
    providerUnavailable
}) => (
    <div className="template template-primary flex-container-v">
        <div className="entete hideNav" id="entete">
            <div className="flex-container-v">
                <header className="tetedepage conteneur flex-container-h flex-center-alt">
                    <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                        <Logo />
                    </LocalizedNavLink>
                    <Stepper steps={i18n.STEPS} current={2} />
                </header>
            </div>
        </div>

        <main id="p-ebon-error" className="conteneur conteneur-mobile">
            <HeadComponent
                title={i18n.ERROR.TITLE}
                description={i18n.DESCRIPTION}
                canonicalLink={`${CONTEXT_ROOT}${PATH.EBON_ERROR_PATH}-${ebcPartnerId}`}
            />
            <Stepper steps={i18n.STEPS} current={2} cssClass="mobileDisplay" />
            <div className="error-container">
                <h1>{i18n.ERROR.TITLE}</h1>

                {providerUnavailable ? (
                    <ProviderUnavailableBloc i18n={i18n.ERROR} />
                ) : (
                    <PaymentFailureBloc
                        i18n={i18n.ERROR}
                        paymentId={paymentId}
                        status={status}
                        partner={partner}
                    />
                )}
            </div>
        </main>
    </div>
);

ErrorEbonPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const ebcPartnerId = getPartnerIdFromQuery(ownProps.match.url);
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paymentId = orderId ? params.orderId.replaceAll('-', '').substr(0, 8) : null;

    const partnerId = ownProps.match.params.id;

    return {
        i18n: state.i18n.page.EBON,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        ebcPartnerId,
        paymentId,
        partner: getPartner(state, partnerId),
        status: params.code,
        // commande e-card annulée par le fournisseur temps réel
        providerUnavailable: params.provider === 'unavailable'
    };
};

export default withRouter(connect(mapStateToProps)(ErrorEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPage.js